import React from 'react'
import styled from 'styled-components'

export const Wrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: -5px;
  pointer-events: none;
  padding: 0;

  .tag-wrapper {
    display: block;
    max-width: 250px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 10px 5px 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    position: fixed;
    opacity: 0;
    visibility: hidden;
    z-index: 2;
  }

  &:hover {
    .tag-wrapper {
      opacity: ${props => props.noHover ? 0 : 1};
      visibility: visible;
    }
  }
`
export const Tag = styled.li`
  display: inline-block;
  font-size: 12px;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 2px 10px;
  max-width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  margin-right: 5px;
  margin-bottom: 5px;
  white-space: nowrap;
  color: #1890ff;
  background: #e6f7ff;
`
export const ShowAllTagsButton = styled.span`
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  width: 25px;
  height: 25px;
  line-height: 22px;
  pointer-events: auto;
  border: 1px solid #91d5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  background: #e6f7ff;

  &:hover {
    cursor: pointer;
  }
`
